import React, { Component } from "react";
import { getItem } from "../../util/util";

/**
 * 授权地址跳转
 */
export default class Auth extends Component {
  componentDidMount = () => {
    const unionid = getItem("unionid");
    if (!unionid) {
      document.location.href = `${window.authBaseUrl}${window.returnUrl}`;
    } else {
      this.props.history.push("/home");
    }
  };

  render() {
    return null;
  }
}
